import React, { FC } from 'react';
import './forecast-boxes-table-row.scss';
import { Checkbox } from 'primereact/checkbox';
    
export interface ForecastBoxesTableRowProps {
    id: string;
    name: string;
    three_liter: boolean;
    five_liter: boolean;
    seven_liter: boolean;
    
    setChecked: (checked: boolean, id: string, boxSize: string) => void;
}

const ForecastBoxesTableRow:FC<ForecastBoxesTableRowProps> = (stock) => {
    return (
        <div className="forecast-boxes-table-row">
            <div className="forecast-boxes-table-row__label">{stock.name}</div>
            <Checkbox 
                onChange={e => stock.setChecked(e.checked, stock.id, 'seven_liter')} 
                checked={stock.seven_liter}
            />
            <Checkbox 
                onChange={e => stock.setChecked(e.checked, stock.id, 'five_liter')} 
                checked={stock.five_liter}
            />
            <Checkbox 
                onChange={e => stock.setChecked(e.checked, stock.id, 'three_liter')} 
                checked={stock.three_liter}
            />
        </div>
    );
}
         
export default ForecastBoxesTableRow;